import { onDomReady, onResizeWindow } from './events';

export function isMobile() {
  return isIos() || isAndroid();
}

export function isIos() {
  return getNormalizedUserAgent().match(/(ipad|iphone|ipod)/g);
}

export function isSafari() {
  // lifted from https://stackoverflow.com/a/31732310
  return (
    navigator.vendor &&
    navigator.vendor.indexOf('Apple') > -1 &&
    navigator.userAgent &&
    navigator.userAgent.indexOf('CriOS') == -1 &&
    navigator.userAgent.indexOf('FxiOS') == -1
  );
}

export function isRunningOnIosAsPwa() {
  return isIos() && ('standalone' in window.navigator) && window.navigator.standalone;
}

export function isAndroid() {
  return getNormalizedUserAgent().indexOf('android') > -1;
}

export function isMobileWidth() {
  return window.matchMedia('(max-width: 639px)').matches;
}

let _userAgent;
function getNormalizedUserAgent() {
  if (typeof _userAgent === 'undefined') {
    _userAgent = navigator.userAgent.toLowerCase();
  }
  return _userAgent;
}
